import React from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'react-redux-form';
import { Checkbox, Col, ControlLabel, FormGroup, Radio, Row } from 'react-bootstrap';
import classnames from 'classnames';
import { capitalize } from 'lodash';
import RequiredSelect from '../../../../common/form/elements/required-select';
import ImageUpload from '../../../../common/form/elements/image-upload';
import RequiredInput from '../../../../common/form/elements/required-input';
import RequiredDatePicker from '../../../../common/form/elements/required-datepicker';
import MultiSelect from '../../../../common/form/multi-select';
import DatePicker from '../../../../common/form/datepicker';
import ArrowButton from '../../../../common/button-arrow';
import SectionTitle from '../../../../common/section-title/index';
import ColorPicker from '../../../../common/form/elements/color-picker';
import { saveArticle, updateArticle } from '../../../../../actions/news';
import GroupMultiSelect from '../../../../common/groups/group-multi-select';
import TextInput from '../../../../common/form/elements/text-input';
import { tradeSiteDisabled, TradeSiteOnly } from '../../../../../utils/toggles';

class EditArticleForm extends React.Component {
  // eslint-disable-next-line consistent-return, class-methods-use-this
  generatePermissions(permissions) {
    if (permissions.length) {
      return (
        permissions.map((permission, index) => (
          <FormGroup
            className="permission-block"
            key={`perm-group-${index}`}
          >
            <b>
              {permission.name}
            </b>
            {
              permission.children
                .filter(child => !['ABM', 'RBM', 'Ordering Store', 'Non Ordering Store', 'Incentive eligible Store'].includes(child.name))
                .map((child, permissionIndex) => (
                  <Control.checkbox
                    component={Checkbox}
                    key={`perm-${permissionIndex}`}
                    model={`.permission_ids[${child.id}].checked`}
                  >
                    {child.name}
                  </Control.checkbox>
              ))
            }
          </FormGroup>
        ))
      );
    }
  }

  onSubmit(payLoad) {
    const { dispatch, article } = this.props;

    if (article.id) {
      dispatch(actions.submitFields('deep.admin_news.article', updateArticle(article.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_news.article', saveArticle(payLoad)));
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(actions.resetValidity('deep.admin_news.article'));
  }

  render() {
    const {
      article, articleForm, loginStatuses, ...props
    } = this.props;

    let image;
    let bannerImage;
    let mobileImage;
    let icon;
    let displayFromDate = '';
    let displayToDate = '';
    let linkedArticles = [];
    let titleTextColour;
    let { permissions } = props;
    let groupIds = [];
    let all = false;

    const { attributes } = article;

    if (attributes) {
      image = attributes.link ? attributes.link.image : undefined;
      bannerImage = attributes.link ? attributes.link['banner-image'] : undefined;
      mobileImage = attributes.link ? attributes.link['mobile-image'] : undefined;
      icon = attributes.link ? attributes.link.icon : undefined;
      displayFromDate = attributes['display-from-date'];
      displayToDate = attributes['display-to-date'];
      linkedArticles = attributes['linked-articles'];
      titleTextColour = attributes['title-text-colour'];
      all = attributes['all-groups'];
      // eslint-disable-next-line prefer-destructuring
      permissions = attributes.permissions;
    }

    if (articleForm && articleForm.group_ids) {
      groupIds = articleForm.group_ids;
    }

    const isPostLogin = tradeSiteDisabled() || articleForm.login_status === 'post_login';
    const hideGroups = !isPostLogin;
    const hidePermissions = !isPostLogin;
    const sizeLimit = 1024 * 1024;

    return (
      <Form
        model="deep.admin_news.article"
        onSubmit={this.onSubmit.bind(this)}
        validators={{
          '': {
            featured: vals => vals.featured,
            display_location: vals => vals.display_location,
            login_status: vals => tradeSiteDisabled() || vals.login_status
          }
        }}
      >
        <Row className="pull-right">
          <Col lg={12}>
            <ArrowButton
              arrow={false}
              className="pull-right"
              disabled={!props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredInput
              controlId='title'
              label="Title"
              model='.title'
              placeholder="Title"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup controlId="titleTextColour">
              <ColorPicker
                model="deep.admin_news.article.title_text_colour"
                textModel="deep.admin_news.article.title_text_colour"
                name="deep.admin_news.article.title_text_colour"
                textName="deep.admin_news.article.title_text_colour"
                label="Title text colour*"
                defaultColor={titleTextColour || 'White'}
                defaultTextColor={titleTextColour}
                backgroundColorPicker={false}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect
              controlId="newsCategory"
              label="Category"
              labelAttr='attributes.name'
              model=".news_category_id"
              valueAttr='id'
              values={props.categoryList}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".image"
              required
              sizeLimit={sizeLimit}
              source={image}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".banner_image"
              label="Upload a banner image"
              sizeLimit={sizeLimit}
              source={bannerImage}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ImageUpload
              model=".mobile_image"
              label="Upload a mobile image"
              sizeLimit={sizeLimit}
              source={mobileImage}
              type={['image/png', 'image/jpg', 'image/jpeg']}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredSelect
              controlId="brandCategory"
              label="Status"
              model=".status"
              values={props.statusList}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <RequiredDatePicker
              controlId="displayFromDate"
              label="Display from date"
              model="deep.admin_news.article.display_from_date"
              placeholder="Select a date..."
              timeFormat="HH:mm"
              value={displayFromDate}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <DatePicker
              label="Display to date"
              model="deep.admin_news.article.display_to_date"
              placeholder="Select a date..."
              timeFormat="HH:mm"
              value={displayToDate}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <FormGroup
              className="display-location-block"
            >
              <div>
                Display location*
              </div>
              <Control.radio
                model=".display_location"
                value="website"
                inline
                component={Radio}
              >
                Website only
              </Control.radio>
              <Control.radio
                model=".display_location"
                value="app"
                inline
                component={Radio}
              >
                App only
              </Control.radio>
              <Control.radio
                model=".display_location"
                value="both"
                inline
                component={Radio}
              >
                Both
              </Control.radio>

              <Errors
                className="errors"
                messages={{display_location: 'You must set display location.'}}
                model="deep.admin_news.article"
                show={{touched: true}}
              />
            </FormGroup>
          </Col>
        </Row>
        { (articleForm.display_location === 'app' || articleForm.display_location === 'both') && (
          <Row>
            <Col lg={12}>
              <ImageUpload
                model=".icon"
                label="Upload an icon"
                required
                sizeLimit={1024 * 1024}
                source={icon}
                type={['image/png', 'image/jpg', 'image/jpeg']}
              />
            </Col>
          </Row>
        ) }

        <Row>
          <Col lg={12}>
            <FormGroup>
              <ControlLabel>
                Featured article
              </ControlLabel>
              <br/>

              <Control.radio
                model=".featured"
                value="true"
                inline
                component={Radio}
              >
                Yes
              </Control.radio>

              <Control.radio
                model=".featured"
                value="false"
                inline
                component={Radio}
              >
                No
              </Control.radio>

              <Errors
                className="errors"
                messages={{featured: 'You must set featured state.'}}
                model="deep.admin_news.article"
                show={{touched: true}}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <SectionTitle>
              Article permissions
            </SectionTitle>
            <TradeSiteOnly>
              <FormGroup>
                <div>Login status*</div>
                {loginStatuses.map(status => (
                  <Control.radio
                    model=".login_status"
                    key={status}
                    value={status}
                    inline
                    component={Radio}
                  >
                    {capitalize(status).replace('_', '-')}
                  </Control.radio>
                ))}

                <Errors
                  className="errors"
                  messages={{login_status: 'You must set login status.'}}
                  model="deep.admin_news.article"
                  show={{touched: true}}
                />
              </FormGroup>
            </TradeSiteOnly>
            <div className={classnames({ hidden: hideGroups })}>
              <GroupMultiSelect
                all={all}
                model={'deep.admin_news.article.group_ids'}
                required={false}
                value={groupIds}
              />
            </div>
          </Col>
        </Row>
        <Row className={classnames({ hidden: hidePermissions })}>
          <Col lg={12}>
            {this.generatePermissions(permissions)}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <MultiSelect
              controlId="linkedArticles"
              data={props.linkArticles}
              label="Linked articles"
              labelAttr="title"
              model="deep.admin_news.article.linked_article_ids"
              value={linkedArticles}
              valueAttr="id"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId='videoLink'
              label="Video Link"
              model='.video_link'
              placeholder="Video Link"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <TextInput
              controlId='gameLink'
              label="Game Link"
              model='.game_link'
              placeholder="Game Link"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <ArrowButton
              arrow={false}
              className="pull-right"
              disabled={!props.formValid}
            >
              Save
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_news.article.$form.valid,
  articleForm: state.deep.admin_news.article,
  loginStatuses: state.news.articles.editorInput.login_statuses
});

export default connect(mapStateToProps)(EditArticleForm);



// WEBPACK FOOTER //
// ./src/components/admin/news/articles/edit/article-edit-form.jsx